module.exports = __webpack_public_path__ + "static/media/vermilion-border-dark.f568737e.png";